import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Button, Modal } from 'react-bootstrap';
import { FormValidator } from '../../helpers/form-validator';
import { Aux, Icon, Heading6, Validator } from '../widgets';
import { getUserId } from '../../helpers/session';
import "../../../assets/css/react-datetime.css";
import { getFarmCustomerList, saveCustomer } from '../../actions/customer';
import { uuid } from '../../helpers/common';

const CustomerForm = (props) => {
	const getValidationRules = () => {
		return new FormValidator([
			{
				field: 'customerName',
				method: 'isEmpty',
				validWhen: false,
				message: 'Customer name is required.'
			}
		])
	}

	let validator = getValidationRules();

	const initialState = {
		customerName: "",
		submitted: false,
		isSaving: false,
		validation: validator.valid()
	};

	const dispatch = useDispatch();

	const [state, setValue] = useState(initialState);

	const setState = (params) => { setValue({ ...state, ...params }); }

	useEffect(() => {
		if (props.isEditMode && props.info) {
			setState({
				isEditMode: true,
				customerName: props.info.customer_name,
			})
		}
	}, [])

	const handleChange = (event) => {
		const { name, value } = event.target;
		const namePattern = name === 'rate' ? (value ? Number(value.replace(/[^\w.]/g, '')) : null) : value.replace(/[^\sa-zA-z.']/g, '');
		setState({ [name]: namePattern });
	}

	const saveResource = () => {
		const validation = validator.validate(state);
		setState({ validation, submitted: true });

		if (validation.isValid) {
			const s = state;
			const cb = (isSuccess) => {
				if (isSuccess) {
					props.onHide();
					dispatch(getFarmCustomerList({ farm_uuid: props.farmId }));
				}
				else setState({ isSaving: false })
			}

			setState({ isSaving: true })

			const params = {
				farm_uuid: props.farmId,
				customer_name: s.customerName,
				created_by: getUserId()
			}

			if (!props.isEditMode) {
				params.customer_uuid = uuid();
				dispatch(saveCustomer(params, cb));
			}
			else {
				params.customer_uuid = props.info.customer_uuid;
				dispatch(saveCustomer(params, cb));
			}
		}
	}

	const s = state;
	const validation = s.submitted ? validator.validate(state) : state.validation;

	return (<Modal show={true} onHide={props.onHide} backdrop="static" className="modal-form">
		<Form className="eg-form m-1">
			<Modal.Header closeButton>
				<Modal.Title>
					<Heading6>
						{!props.isEditMode ? "Add Customer" : "Edit Customer"}
					</Heading6>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="py-0">
				<Aux>
					<Form.Group>
						<Validator validation={validation.customerName}>
							<Form.Label htmlFor="customerName">Name <Validator.Mand /></Form.Label>
							<Form.Control id="customerName" type="text" placeholder="Enter the name" className="form-control" autoComplete="off"
								value={s.customerName} name="customerName" onChange={handleChange} />
							<Validator.Text />
						</Validator>
					</Form.Group>
				</Aux>
			</Modal.Body>
			<Modal.Footer>
				<Button size="sm" variant="danger" className="mr-2" onClick={props.onHide}><Icon className="fa fa-times"></Icon> Cancel</Button>
				<Button size="sm" variant="primary" onClick={saveResource}><Icon className="fa fa-floppy-o"></Icon> {state.isSaving ? "Saving" : "Save"}</Button>
			</Modal.Footer>
		</Form>
	</Modal >)
}



export default CustomerForm;